import React from 'react';
type SectionHeadingProps = {
  eyebrow: string;
  title: React.ReactNode;
  description?: string;
  tone?: 'light' | 'dark';
  align?: 'left' | 'center';
};
export function SectionHeading({
  eyebrow,
  title,
  description,
  tone = 'light',
  align = 'left'
}: SectionHeadingProps) {
  const isDark = tone === 'dark';
  return <div className={align === 'center' ? 'mx-auto max-w-3xl text-center' : 'max-w-3xl'} data-id="element-136" data-mp="3k0ygy8sfb398">
      <div className={`flex items-center gap-4 ${align === 'center' ? 'justify-center' : ''}`} data-id="element-137" data-mp="blerzlysc6zz">
        <span className="font-mono text-[11px] uppercase tracking-[0.28em] text-brass" data-id="element-138" data-mp="gix2hgsgaua3">
          {eyebrow}
        </span>
        <span className="h-px w-16 rule-brass" aria-hidden="true" data-id="element-139" data-mp="1sheju8nh888" />
      </div>
      <h2 className={`mt-6 font-display text-4xl leading-[1.05] tracking-tight sm:text-5xl lg:text-[3.4rem] ${isDark ? 'text-ivory' : 'text-ink'}`} data-id="element-140" data-mp="6s2h0en13ypp">
        {title}
      </h2>
      {description && <p className={`mt-6 text-lg leading-relaxed ${isDark ? 'text-ivory/65' : 'text-muted-foreground'}`} data-id="element-141" data-mp="1t9yyjs9fsaih">
          {description}
        </p>}
    </div>;
}